import { Component, OnInit } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PortalManagementCustomersService } from 'src/app/features/portal/_services/management/portal-management-customers.service';

@Component({
  selector: 'app-update-customer-contact-details',
  templateUrl: './update-customer-contact-details.component.html',
  styleUrls: ['./update-customer-contact-details.component.scss']
})
export class UpdateCustomerContactDetailsComponent implements OnInit {
  rsaPhoneNumberRegex: RegExp = /^(?:27|0)\d{9,11}$/;

  formContactDetails: FormGroup = this.fb.group({
    first_name: ['', Validators.required],
    last_name: ['', Validators.required],
    email: [''], // No validators initially
    mobile_number: ['', [Validators.required, Validators.pattern(this.rsaPhoneNumberRegex)]]
  });

  // Add conditional email validation

  formFields: any[] = [
    {
      controlName: 'first_name',
      label: 'First Name',
      type: 'text',
      errorMessage: '* Please enter your first name',
      validators: { required: true }
    },
    {
      controlName: 'last_name',
      label: 'Last Name',
      type: 'text',
      errorMessage: '* Please enter your last name',
      validators: { required: true }
    },
    {
      controlName: 'email',
      label: 'Email Address',
      type: 'email',
      errorMessage: '* Please enter a valid email address',
      validators: { email: true }
    },
    {
      controlName: 'mobile_number',
      label: 'Cellphone/Mobile Number',
      type: 'tel',
      errorMessage: '* Please enter your mobile number',
      validators: { required: true }
    }
  ];

  errorMessage: string = '';

  constructor(
    private fb: FormBuilder,
    private pmcs: PortalManagementCustomersService,
    public config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    public messageService: MessageService
  ) {}

  ngOnInit(): void {
    console.log('config', this.config.data.customer);
    this.formContactDetails.patchValue({
      first_name: this.config.data.customer.first_name,
      last_name: this.config.data.customer.last_name,
      email: this.config.data.customer.email || '',
      mobile_number: this.config.data.customer.mobile_number
    });

    this.formContactDetails.get('email')?.valueChanges.subscribe((value) => {
      const emailControl = this.formContactDetails.get('email');
      if (value !== '' && value !== null) {
        emailControl?.setValidators([Validators.email]);
      } else {
        emailControl?.clearValidators();
      }
      emailControl?.updateValueAndValidity();
    });
  }

  get f() {
    return this.formContactDetails.controls;
  }

  onBlur($event: FocusEvent) {
    throw new Error('Method not implemented.');
  }

  onContactDetailsUpdateSubmit() {
    console.log('onContactDetailsUpdateSubmit', this.formContactDetails.value);

    this.errorMessage = '';

    // Check if the form is valid
    if (this.formContactDetails.invalid) {
      console.log('Form is invalid');
      this.errorMessage = 'Please fill in all required fields.';
      this.formContactDetails.markAllAsTouched();
      return;
    }

    // if (this.formContactDetails.valid) {

    // }

    this.pmcs
      .updatePortalCustomerContactDetails(
        this.config.data.customer.id,
        this.formContactDetails.value
      )
      .subscribe(
        (res) => {
          console.log('Update Customer Contact Details', res);
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Customer contact details updated successfully.'
          });

          this.ref.close(res);
        },
        (error) => {
          console.error('Error updating customer contact details', error);
          this.errorMessage = 'Failed to update contact details. Please try again.';
        }
      );
  }
}
